export default __webpack_public_path__ + "static/media/humidity.3034974f.svg";